/* RAJATHEE: WhatsApp lead pop-up (KCOM, Nov 2026). Markup and styles in snippets/rj-wa-popup.liquid. */
(function () {
  var el = document.getElementById('rjwa');
  var dataEl = document.getElementById('rj-wa-data');
  if (!el || !dataEl) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var SEEN = 'rj_wa_seen', DONE = 'rj_wa_done';
  var SEEN_MS = 3 * 864e5, DONE_MS = 60 * 864e5;
  function get(k) { try { return +localStorage.getItem(k) || 0; } catch (e) { return 0; } }
  function set(k) { try { localStorage.setItem(k, String(Date.now())); } catch (e) {} }
  var forced = /[?&]rjwa=1/.test(location.search);
  if (!forced && (Date.now() - get(DONE) < DONE_MS || Date.now() - get(SEEN) < SEEN_MS)) return;

  var msg = D.product
    ? 'Hi Rajathee, I am interested in: ' + D.product + '. ' + D.url
    : 'Hi Rajathee, I need help choosing a saree.';
  var chat = document.getElementById('rjwa-chat');
  chat.href = 'https://wa.me/' + D.number + '?text=' + encodeURIComponent(msg);

  var shown = false, startedAt = Date.now();
  function busy() {
    // do not interrupt the free-saree pop-up, an open cart drawer or any open modal
    return !!document.querySelector('dialog[open], .rjfg[open], #rj-checkout-overlay, #addon-popup-overlay[style*="flex"]');
  }
  function open(reason) {
    if (shown) return;
    if (busy()) { setTimeout(function () { open(reason); }, 8000); return; }
    shown = true; set(SEEN);
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (window.fbq) try { fbq('trackCustom', 'WhatsAppPopupShown', { trigger: reason }); } catch (e) {}
  }
  function close() {
    el.hidden = true;
    document.documentElement.style.overflow = '';
  }
  el.addEventListener('click', function (e) { if (e.target.closest('[data-rjwa-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });

  chat.addEventListener('click', function () {
    set(DONE);
    if (window.fbq) try { fbq('track', 'Contact', { content_name: D.product || D.page }); } catch (e) {}
    setTimeout(close, 300);
  });

  // triggers: time on page, plus exit intent on desktop
  setTimeout(function () { open('timer'); }, forced ? 800 : D.delay);
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0 && Date.now() - startedAt > 8000) open('exit');
  });

  // call-back form -> Google Sheet "Rajathee Website Leads" (Apps Script web app, KCOM account)
  var LEADS_URL = 'https://script.google.com/macros/s/AKfycbx7Le6zoSO9U-vsyUcpuDCd9rzerlTSjmMlb1-Yk8yaZD2RJzTPw3guTc5Tsmpov3rdPA/exec';
  var form = document.getElementById('rjwa-form');
  var err = document.getElementById('rjwa-err');
  function fail(t) { err.textContent = t; err.hidden = false; }
  form.addEventListener('submit', function (e) {
    e.preventDefault(); err.hidden = true;
    var name = form.elements['name'].value.trim();
    var phone = form.elements['phone'].value.replace(/\D/g, '').replace(/^(91|0)(?=\d{10}$)/, '');
    if (!/^[6-9]\d{9}$/.test(phone)) return fail('Please enter a valid 10-digit mobile number.');
    if (!form.elements['consent'].checked) return fail('Please tick the box so we can message you on WhatsApp.');
    var btn = form.querySelector('.rjwa__go'); btn.disabled = true; btn.textContent = 'Sending...';

    fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
      var cartLine = cart && cart.item_count
        ? cart.item_count + ' item(s), Rs ' + (cart.total_price / 100).toFixed(0) + ': ' + cart.items.map(function (i) { return i.product_title; }).join(', ')
        : 'empty';
      var body = new URLSearchParams({ name: name || '-', phone: phone, product: D.product || '', cart: cartLine, page: location.href, consent: 'yes' });
      return fetch(LEADS_URL, { method: 'POST', mode: 'no-cors', body: body }).then(done);
    }).catch(function () {
      // fallback: the visitor sends the request to Rajathee on WhatsApp directly
      var m = 'Hi Rajathee, please call me back on WhatsApp. Name: ' + (name || '-') + ', Mobile: ' + phone + (D.product ? ', interested in ' + D.product : '');
      window.open('https://wa.me/' + D.number + '?text=' + encodeURIComponent(m), '_blank');
      done();
    });

    function done() {
      set(DONE);
      if (window.fbq) try { fbq('track', 'Lead', { content_name: D.product || D.page }); } catch (e) {}
      form.hidden = true;
      el.querySelector('.rjwa__or').hidden = true;
      chat.hidden = true;
      document.getElementById('rjwa-done').hidden = false;
      setTimeout(close, 3500);
    }
  });
})();
